module.exports = __webpack_public_path__ + "img/10.565c792b.jpg";